import { render, staticRenderFns } from "./TreatmentSketchs.vue?vue&type=template&id=6e2362d5&scoped=true&"
import script from "./TreatmentSketchs.vue?vue&type=script&lang=js&"
export * from "./TreatmentSketchs.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSketchs.vue?vue&type=style&index=0&id=6e2362d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2362d5",
  null
  
)

export default component.exports